import {Component, Input, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-tabela',
    templateUrl: './tabela.component.html',
    styleUrl: './tabela.component.css',
    standalone: false
})
export class TabelaComponent {
  @Input() colunas: string[] = [];
  @Input() linhas: any[] = [];
  @Input() checkSelecionar = false;
  @Input() camposFiltro = true;
  @Input() titulo: string = ``;
  @Input() placeHolder: string = ``;
  @Input() botaoEditar = false;
  @Input() botaoDeletar = false;
  @Input() linkBotaoEditar = ``;
  @Input() campoPesquisa = true;
  @Input() desativar: Function;

  paginaAtual = 1;
  quantidadeColunas = 0;

  constructor() {
    this.quantidadeColunas = this.colunas.length;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['colunas']) {
      this.quantidadeColunas = this.colunas.length;
    }
    if (changes['linhas']) {
      this.paginaAtual = 1;
    }
  }

  deletar(id: number) {
    this.desativar(id);
  }

  termoBusca = '';
  filtro = false;
  listaFiltrada: any[];

  limparFiltro(){
    this.termoBusca = '';
    this.filtro = false;
  }

  public pageChange(event: number){
    this.paginaAtual = event;
  }

  buscarLista(){
    if(this.termoBusca.length > 0){
      this.filtro = true;
      this.listaFiltrada = this.linhas.filter(item => {
        return Object.keys(item).some(key => item[key]?.toString().toLowerCase().includes(this.termoBusca.toLowerCase()));
      });
    }
    else{
      this.listaFiltrada = this.linhas;
      this.filtro = false;
    }
  }
}
